import { DatePicker } from './date-picker';
import { parseCalendarDate, toCalendarDate } from '../../lib/utils';

/** First year offered. Older than any contact we will ever store. */
const EARLIEST_BIRTH_YEAR = 1920;

/**
 * Birthday field — the app's DatePicker, speaking the API's 'YYYY-MM-DD'
 * calendar string instead of a Date.
 *
 * That conversion is the only reason this wrapper exists: `birthday` is
 * deliberately a plain calendar date, and both obvious conversions shift it by a
 * day (see `parseCalendarDate`). Keeping it here means the two call sites can't
 * each get it subtly wrong.
 */
export function BirthdayPicker({
	value,
	onChange,
	disabled = false,
}: {
	/** Calendar date, 'YYYY-MM-DD', or null when unset. */
	value: string | null;
	onChange: (value: string | null) => void;
	disabled?: boolean;
}) {
	return (
		<DatePicker
			value={parseCalendarDate(value)}
			onChange={(date) => onChange(toCalendarDate(date))}
			placeholder="Pick a birthday"
			disabled={disabled}
			clearable
			startMonth={new Date(EARLIEST_BIRTH_YEAR, 0)}
			endMonth={new Date()}
		/>
	);
}
